import APIClient from '@/shared/http/clients/api'

const resourceName = 'notifications-atendimento'
const APICore = process.env.APIBaseURLCore

const searchNotificationsUser = (config = {}) => APIClient.get(`${APICore}/${resourceName}/notifications/user`, config)
const searchNotificationsUserViewdTrue = (config = {}) => APIClient.get(`${APICore}/${resourceName}/notifications/user?visualizado=true`, config)
const searchNotificationsUserViewdFalse = (config = {}) => APIClient.get(`${APICore}/${resourceName}/notifications/user?visualizado=false`, config)
const searchNotificationsUserCustom = (filter, config = {}) => APIClient.get(`${APICore}/${resourceName}/notifications/user?${filter}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/notifications`, data, config)
const Update = (id, config = {}) => APIClient.put(`${APICore}/${resourceName}/notifications/${id}`, config)

const NotificationsAtendimentoRepository = {
  searchNotificationsUser,
  Create,
  Update,
  searchNotificationsUserViewdTrue,
  searchNotificationsUserViewdFalse,
  searchNotificationsUserCustom
}

export default NotificationsAtendimentoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/notificationsatendimento.js